/**
 * bootSplash.ts — M158c: retire the app's animated startup layer
 * (#boot-splash in index.html) once the home screen is ready. It stays at
 * least BOOT_MIN_MS from page start so the logo's light sweep reads, then
 * fades out. A no-op on the website (the layer is never shown there).
 */
const BOOT_MIN_MS = 2400;

export function dismissBootSplash(): void {
  const root = document.getElementById('boot-splash');
  if (!root) return;
  if (!document.documentElement.classList.contains('boot-on')) {
    root.remove();
    return;
  }
  const wait = Math.max(0, BOOT_MIN_MS - performance.now());
  window.setTimeout(() => {
    // two frames: the home screen under it has painted before it fades
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        root.classList.add('boot-out');
        window.setTimeout(() => {
          root.remove();
          document.documentElement.classList.remove('boot-on');
        }, 700);
      }),
    );
  }, wait);
}
